import React from 'react'
import { DeleteStudentProceedingsDialog, PrimaryCta } from 'components'

function GridDeleteStudentProceeding({ row }) {
  return (
    <DeleteStudentProceedingsDialog
      togglerComponent={PrimaryCta}
      togglerProps={{ size: 'grid' }}
      studentProceeding={row}
    >
      Eliminar del lote
    </DeleteStudentProceedingsDialog>
  )
}

export const MemoizedGridDeleteStudentProceeding = React.memo(
  GridDeleteStudentProceeding
)
